/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class DefaultService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Version
   * バージョン情報を取得
   * @returns any Successful Response
   * @throws ApiError
   */
  public getVersion(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/version"
    });
  }

  /**
   * Get Health
   * ヘルスチェック
   * @returns any Successful Response
   * @throws ApiError
   */
  public getHealth(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/health"
    });
  }
}
